<template>
    <div class="device" @click="clickMeNow">
        <vue-draggable-resizable :parent="true" :resizable="false" drag-handle=".header" :x="left" :y="top">
            <div class="window">
                <div class="header" :style="{ width: deviceWidth + 'px' }">
                    <span class="id" style="overflow: hidden;height: 36px;">{{ remark?'备注:'+ remark:id }}</span>
                    <div v-show="camera || video" style="color: #409EFF;font-size: 12px;padding-right: 5px">{{camera ?
                        '摄像头同步中' :
                        '视频同步中'}}
                    </div>
                    <el-button style="margin-right: 5px"
                               v-show="(camera && !$store.getters.getCameraShow(videoDeviceId)) || (video && !$store.getters.videoDisplay(localId))"
                               type="primary" size="mini" @click.stop="showLocal(true)">打开预览
                    </el-button>
                    <el-button style="margin-left: 0!important;margin-right: 5px"
                               v-show="(camera && $store.getters.getCameraShow(videoDeviceId)) || (video && $store.getters.videoDisplay(localId))"
                               type="primary" size="mini" @click.stop="showLocal(false)">关闭预览
                    </el-button>
                    <div v-show="!camera && !video"
                         style="float: right;display: flex;flex-direction: row;align-items: center"
                         v-if="checkLicenseService(5) !== -1">
                        <el-button :disabled="video || !status" size="mini" type="primary" @click.stop="getCameraList">
                            摄像头
                        </el-button>
                        <el-tooltip placement="top" style="padding: 0 5px">
                            <div slot="content" style="max-width: 400px">
                                将本地PC摄像头与云机摄像头同步，延迟约在200ms以内，可查看本地画面进行实时对比。当前最多支持10台云机进行同步。目前仅支持最新版chrome浏览器。
                            </div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </div>
                    <i v-if="!video && !camera" class="close el-icon-close" @click.stop="closeClick"></i>
                    <div v-else style="display: flex;justify-content: center;align-items: center;"
                         @click="setCameraRotation">
                        <el-tooltip placement="top" style="padding: 0 5px;height: 28px">
                            <div slot="content" style="max-width: 400px">
                                点击后摄像头画面顺时针旋转90°
                            </div>
                            
                            <span class="el-dropdown-link">
         
                <img src="../assets/rotate.png" style="width: 18px;"/>
              </span>
                        </el-tooltip>

                        <el-tooltip placement="top" style="padding: 0 5px">
                            <div slot="content" style="max-width: 400px">
                                关闭本地摄像头同步模式
                            </div>
                            <i class="close el-icon-switch-button" style="color: red" @click.stop="closeLocal()"></i>
                        </el-tooltip>
                    </div>
                </div>
                <div class="body-area" :style="{ width: deviceWidth + 'px', height: deviceHeight + 'px' }">
                    <div class="body" :style="{ width: deviceWidth + 'px', height: deviceHeight + 'px' }">
                        <div v-if="deviceMessage && !error" class="message"> {{ deviceMessage }}</div>
                        <div v-if="error" class="message"
                             style="display: flex;flex-direction: column;align-items: center;width: 100%"
                             @click.stop="openPlayer">
                            <div style="padding-bottom: 40px">{{ deviceMessage }}</div>
                            <i class="el-icon-refresh" style="font-size: 40px"></i>
                            <div>点击刷新推流</div>
                        </div>
                        <div :id="'target' + id"
                             :style="{ width: deviceWidth + 'px', height: deviceHeight + 'px' }"></div>
                    </div>
                    <div class="body-right" style="width: 32px; height: 300px;margin-top: 20px;">
                        <el-button type="primary" size="small" style="width: 32px; height: 150px;margin-bottom: 2px;"
                                   @click.stop="showModelClick"><span style="writing-mode:tb-rl;letter-spacing: 2px;">机型参数</span>
                        </el-button>
                        <el-button type="primary" size="small" style="width: 32px;height:150px;margin-left: 0px;"
                                   @click.stop="showCpuClick"><span
                                style="writing-mode:tb-rl;letter-spacing: 2px;">性能监控</span></el-button>
                        
                    </div>
                    <div class="phone-param"
                         :style="{ width: deviceWidth + 20 + 'px',height: deviceHeight - 50 + 'px' , left:deviceWidth + 'px', top: 0}"
                         v-if="phoneParamShow">
                        <div class="phone-param_header">
                            <span style="margin-left: 10px;font-size: 12px;letter-spacing: 1px;">机型参数</span>
                            <i class="close el-icon-close" @click.stop="phoneParamShow=false"></i>
                        </div>
                        <div class="phone-param_body">
                            <el-form
                                    :model="modelInfo"
                                    label-width="120px"
                                    label-position="left"
                            >
                                <el-form-item size="mini" label="ROOT开关:">
                                    <el-switch v-if="!modelEdit" v-model="modelInfo.isRoot" :active-value="'1'"
                                               :inactive-value="'0'"
                                               :disabled="true" active-color="#13ce66"
                                               inactive-color="#ff4949"></el-switch>
                                    <el-switch v-else size="mini" v-model="modelInfo.isRoot" :active-value="'1'"
                                               :inactive-value="'0'"
                                               active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                                </el-form-item>
                                <el-form-item size="mini" label="厂商:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.company"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="品牌:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.brand"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="型号:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.model"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="序列号:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.seriesNum"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="Android Id:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.androidId"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="imei:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.imei"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="imsi:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.imsi"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="wifi mac:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.wifiMac"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="wifi名称:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.wifiName"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="wifi ip:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.wifiIp"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="蓝牙名称:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.btname"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="蓝牙mac:">
                                    <el-input size="mini" v-model.trim="modelInfo.btaddr"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="手机号:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.phoneno"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="type:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.type"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="user:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.user"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="displayId:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.displayId"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="基带版本:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.baseVersion"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="运营商:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.operatorname"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="运营商代码:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.numeric"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="Country:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.country"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="安卓版本:">
                                    <el-input readonly size="mini" v-model.trim="modelInfo.androidVersion"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="语言:">
                                    <el-select v-model="modelInfo.language" placeholder="请选择" size="mini"
                                               style="width: 160px;" :disabled="!modelEdit">
                                        <el-option
                                                v-for="item in localeList"
                                                :key="item"
                                                :label="item"
                                                :value="item  | localeValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item size="mini" label="时区:">
                                    <el-select v-model="modelInfo.timeZone" placeholder="请选择" size="mini"
                                               style="width: 160px;" :disabled="!modelEdit">
                                        <el-option
                                                v-for="item in timeZoneList"
                                                :key="item"
                                                :label="item"
                                                :value="item | timeZoneValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item size="mini" label="sim卡状态:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.simStatus"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>

                                <el-form-item size="mini" label="cpu核心数:">
                                    <el-input readonly size="mini" v-model.trim="modelInfo.cpuCoreNum"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="运行内存:">
                                    <el-input readonly size="mini" v-model.trim="modelInfo.ram"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="存储空间:">
                                    <el-input readonly size="mini" v-model.trim="modelInfo.disk"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="buildId:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.buildId"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="productName:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.productName"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="productDevice:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.productDevice"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="productBoard:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.productBoard"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="hardware:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.hardware"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="versionIncremental:">
                                    <el-input :readonly="!modelEdit" size="mini"
                                              v-model.trim="modelInfo.versionIncremental"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="tags:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.tags"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="fingerprint:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.fingerprint"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="dateUtc:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.dateUtc"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="buildHost:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.buildHost"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="debuggable:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.debuggable"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="versionCodename:">
                                    <el-input :readonly="!modelEdit" size="mini"
                                              v-model.trim="modelInfo.versionCodename"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                                <el-form-item size="mini" label="networkType:">
                                    <el-input :readonly="!modelEdit" size="mini" v-model.trim="modelInfo.networkType"
                                              :placeholder="currentPlaceHolder"></el-input>
                                </el-form-item>
                               
                            </el-form>
                        </div>
                        <div class="phone-param_footer" v-if="!modelEdit">
                            <el-button type="primary" :disabled="!modelEditable" size="small"
                                       @click.stop="openModelEdit">自定义参数
                            </el-button>
                        </div>
                        <div class="phone-param_footer" v-else>
                            <el-button type="primary" size="small" @click.stop="confirmModelEdit"
                                       style="margin-right: 10px;">确定
                            </el-button>
                            <el-button type="primary" plain size="small" @click.stop="cancelModelEdit"
                                       style="margin-left: 10px;">取消
                            </el-button>
                        </div>
                    </div>
                    <div class="footer-cpu" :style="{ width: deviceWidth + 'px', height: '200px' }" v-if="cpuShow">
                        <div class="cpu_header">
                            <span style="margin-left: 20px;font-size: 12px;letter-spacing: 1px;">CPU占用</span>
                            <i class="close el-icon-close" @click="cpuShow=false"></i>
                        </div>
                        <div :id="'cpu_box' + id" style="width: 100%; height: 180px;">
                        </div>
                    </div>
                </div>

                <div class="footer" :style="{ width: deviceWidth + 'px' }">
                    <el-tooltip class="tooltip" effect="dark" content="返回键" placement="top-start">
                        <div class="return" @click.stop="returnClick"></div>
                    </el-tooltip>
                    <el-tooltip class="tooltip" effect="dark" content="主页键" placement="top">
                        <div class="home" @click.stop="homeClick"></div>
                    </el-tooltip>
                    <el-tooltip class="tooltip" effect="dark" content="截图" placement="top">
                        <div class="snapshot" @click.stop="snapshotClick"></div>
                    </el-tooltip>
                    <el-tooltip class="tooltip" effect="dark" content="任务键" placement="top">
                        <div class="recent" @click.stop="recentClick"></div>
                    </el-tooltip>
                    <el-tooltip class="tooltip" effect="dark" content="音量+" placement="top">
                        <div class="vol-up" @click.stop="volUpClick"></div>
                    </el-tooltip>
                    <el-tooltip class="tooltip" effect="dark" content="音量-" placement="top">
                        <div class="vol-down" @click.stop="volDownClick"></div>
                    </el-tooltip>
                    <el-tooltip class="tooltip" effect="dark" content="切换横竖屏" placement="top-end">
                        <div class="toogle-orientation" @click.stop="toogleOrientationClick"></div>
                    </el-tooltip>
                    <div style="font-size: 13px;color: white;line-height: 24px" @click.stop="scaleModeChange">
                        {{scaleMode === 0 ? '1.5x' : '1.0x'}}
                    </div>
                </div>
            </div>
        </vue-draggable-resizable>

        <el-dialog
                title="设备截图"
                :visible.sync="dialogVisible"
                :modal="false"
                :append-to-body="true"
                width="30%">
            <div style="display: flex;flex-direction: column;">
                <el-image v-if="url"
                          style="width: 100%;"
                          :src="url"
                          fit="cover"></el-image>
                <el-button type="primary" size="medium" style="margin: 10px 0" @click.stop="downloadPng">下载图片
                </el-button>
                <span style="font-size: 12px;color: red">如无法下载，可右键-图片另存为(图片已默认保存至云机相册内)</span>
            </div>
        </el-dialog>

        <el-dialog
                title="提示"
                :visible.sync="cameraErrorVisible"
                :append-to-body="true"
                width="400">
            <div>检测到您未对chrome浏览器打开摄像头权限</div>
            <br/>
            <div>解决方法如下：</div>
            <br/>
            <div style="padding-left: 20px">1.浏览器进入地址：chrome://flags/#unsafely-treat-insecure-origin-as-secure
                <el-button type="text" @click.stop="copyLink">复制</el-button>
                ，设置
                为enable，并将当前页面域名（http://<span>{{myDomain}}<el-button type="text"
                                                                     @click.stop="copyIp">复制</el-button></span>）添加至文本框后重启浏览器。
            </div>
            <br/>
            <div style="padding-left: 20px">2.点击浏览器地址栏连接左方感叹号按钮，设置摄像头权限为允许。</div>
            <br/>
            <div>如有问题，可查看
                <el-button type="text" @click.stop="goFun">帮助文档-chrome浏览器打开摄像头权限</el-button>
                。
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click.stop="cameraErrorVisible = false">确 定</el-button>
      </span>
        </el-dialog>

        <el-dialog
                title="选择摄像头"
                :visible.sync="cameraSelectVisible"
                :append-to-body="true"
                width="300px">
            <div v-if="cameraSelectVisible" style="display: flex;flex-direction: column;align-items: center">
                <el-select v-model="videoDeviceId" placeholder="请选择">
                    <el-option
                            v-for="item in cameraOption"
                            :key="item.deviceId"
                            :label="item.label"
                            :value="item.deviceId">
                    </el-option>
                </el-select>
                <el-button type="primary" style="margin-top: 30px" @click.stop="openLocalCamera(videoDeviceId)">确定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "DeviceWindow",
        props: {
            id: Number,
            index: {
                type: Number,
                default: 0
            },
            remark: String,
            deviceId: Number,
            appid: {
                type: String,
                default: "0"
            },
            ip: String,
            engineType: Number
        },
        data() {
            return {
                myDomain: "",
                modelEdit: false,
                modelEditable: true,
                modelInfo: {
                    company: "",
                    brand: "",
                    model: "",
                    seriesNum: "",
                    androidId: "",
                    imei: "",
                    imsi: "",
                    wifiMac: "",
                    wifiName: "",
                    btname: "",
                    btaddr: "",
                    phoneno: "",
                    type: "",
                    user: "",
                    displayId: "",
                    baseVersion: "",
                    operatorname: "",
                    numeric: "",
                    country: "",
                    androidVersion: "",
                    language: "",
                    timeZone: "",
                    simStatus: "",
                    wifiIp: "",
                    cpuCoreNum: "",
                    ram: "",
                    disk: "",
                    isRoot: "",
                    buildId: "",
                    productName: "",
                    productDevice: "",
                    productBoard: "",
                    hardware: "",
                    versionIncremental: "",
                    tags: "",
                    fingerprint: "",
                    dateUtc: "",
                    buildHost: "",
                    debuggable: "",
                    versionCodename: "",
                    networkType: "",
                    // latitude:"",
                    // longitude:"",
                    // systemid:"",
                    // networkid:"",
                    // lac:"",
                    // cid:"",
                    // bsid:"",
                },
                cpuShow: false,
                currentCpu: [],
                currentTime: [],
                cpuTimer: null,
                phoneParamShow: false,
                phoneParamSelf: false,
                appkey: 'ffffccec3c124642967fe476cef558c4',
                requestUrl: '/mosico/player/bootstrap',
                reportUrl: '/mosico/player/terminate',
                rotation: 90,
                scaleMode: 0, //0=1x, 1=1.5x
                player: null,
                deviceWidth: 288,
                deviceHeight: 512,
                deviceMessage: "",
                dialogVisible: false,
                url: '',
                camera: false,
                video: false,
                status: false,
                localId: null,
                openVideo: null,
                many: false,
                cameraErrorVisible: false,
                cameraSelectVisible: false,
                cameraOption: [],
                videoDeviceId: null,
                left: 0,
                top: 0,
                codeRate: 0,
                frameRate: 0,
                error: false,
                currentPlaceHolder: '请输入',
                localeList: [
                    "ar-EG-阿拉伯语，埃及",
                    "ar-IL-阿拉伯语，以色列",
                    "bg-BG-保加利亚语，保加利亚",
                    "ca-ES-加泰隆语，西班牙",
                    "cs-CZ-捷克语，捷克共和国",
                    "da-DK-丹麦语，丹麦",
                    "de-AT-德语，奥地利",
                    "de-CH-德语，瑞士",
                    "de-DE-德语，德国",
                    "de-LI-德语，列支敦士登的",
                    "el-GR-希腊语，希腊",
                    "en-AU-英语，澳大利亚",
                    "en-CA-英语，加拿大",
                    "en-GB-英语，英国",
                    "en-IE-英语，爱尔兰",
                    "en-IN—英语，印度",
                    "en-NZ-英语，新西兰",
                    "en-SG-英语，新加坡",
                    "en-US-英语，美国",
                    "en-ZA-英语，津巴布韦",
                    "es-ES-西班牙",
                    "es-US-西班牙语，美国",
                    "fi-FI-芬兰语，芬兰",
                    "fr-BE-法语，比利时",
                    "fr-CA-法语，加拿大",
                    "fr-CH-法语，瑞士",
                    "fr-FR—法语，法国",
                    "he-IL-希伯来语，以色列",
                    "hi-IN-印地语，印度",
                    "hr-HR-克罗地亚语，克罗地亚",
                    "hu-HU-匈牙利语，匈牙利",
                    "id-ID-印尼语，印尼",
                    "it-CH-意大利语，瑞士",
                    "it-IT-意大利语，意大利",
                    "ja-JP-日语",
                    "ko-KR-朝鲜语",
                    "lt-LT-立陶宛语，立陶宛",
                    "lv-LV-拉托维亚语，拉托维亚",
                    "nb-NO-挪威语，挪威",
                    "nl-BE-荷兰语，比利时",
                    "nl-NL-荷兰语，荷兰",
                    "pl-PL-波兰",
                    "pt-BR-葡萄牙语，巴西",
                    "pt-PT-葡萄牙语，葡萄牙",
                    "ru-RU-俄语",
                    "ro-RO-罗马尼亚语，罗马尼亚",
                    "sk-SK-斯洛伐克语，斯洛伐克",
                    "sl-SI-斯洛文尼亚语，斯洛文尼亚",
                    "sr-RS-塞尔维亚语",
                    "sv-SE-瑞典语，瑞典",
                    "th-TH-泰语，泰国",
                    "tl-PH-菲律宾语，菲律宾",
                    "tr-TR-土耳其语，土耳其",
                    "uk-UA-联合王国",
                    "vi-VN-越南语，越南",
                    "zh-CN-中文，中国",
                    "zh-TW-中文，台湾",
                ],
                timeZoneList: [
                    "Pacific/Majuro-马朱罗",
                    "Pacific/Midway-中途岛",
                    "Pacific/Honolulu-檀香山",
                    "America/Anchorage-安克雷奇",
                    "America/Los_Angeles-美国太平洋时间(洛杉矶)",
                    "America/Tijuana-美国太平洋时间(提华纳)",
                    "America/Phoenix-美国山区时间(凤凰城)",
                    "America/Chihuahua-奇瓦瓦",
                    "America/Denver-美国山区时间(丹佛)",
                    "America/Costa_Rica-美国中部时间(哥斯达黎加)",
                    "America/Chicago-美国中部时间(芝加哥)",
                    "America/Mexico_City-美国中部时间(墨西哥城)",
                    "America/Regina-美国中部时间(里贾纳)",
                    "America/Bogota-哥伦比亚时间(波哥大)",
                    "America/New_York-美国东部时间(纽约)",
                    "America/Caracas-委内瑞拉时间(加拉加斯)",
                    "America/Barbados-大西洋时间(巴巴多斯)",
                    "America/Manaus-亚马逊标准时间(马瑙斯)",
                    "America/Santiago-圣地亚哥",
                    "America/St_Johns-纽芬兰时间(圣约翰)",
                    "America/Sao_Paulo-圣保罗",
                    "America/Argentina/Buenos_Aires-布宜诺斯艾利斯",
                    "America/Godthab-戈特霍布",
                    "America/Montevideo-乌拉圭时间(蒙得维的亚)",
                    "Atlantic/South_Georgia-南乔治亚",
                    "Atlantic/Azores-亚述尔群岛",
                    "Atlantic/Cape_Verde-佛得角",
                    "Africa/Casablanca-卡萨布兰卡",
                    "Europe/London-格林尼治标准时间(伦敦)",
                    "Europe/Amsterdam-中欧标准时间(阿姆斯特丹)",
                    "Europe/Belgrade-中欧标准时间(贝尔格莱德)",
                    "Europe/Brussels-中欧标准时间(布鲁塞尔)",
                    "Europe/Sarajevo-中欧标准时间(萨拉热窝)",
                    "Africa/Windhoek-温得和克",
                    "Africa/Brazzaville-西部非洲标准时间(布拉扎维)",
                    "Asia/Amman-东欧标准时间(安曼)",
                    "Europe/Athens-东欧标准时间(雅典)",
                    "Asia/Beirut-东欧标准时间(贝鲁特)",
                    "Africa/Cairo-东欧标准时间(开罗)",
                    "Europe/Helsinki-东欧标准时间(赫尔辛基)",
                    "Asia/Jerusalem-以色列时间(耶路撒冷)",
                    "Europe/Minsk-明斯克",
                    "Africa/Harare-中部非洲标准时间(哈拉雷)",
                    "Asia/Baghdad-巴格达",
                    "Europe/Moscow-莫斯科",
                    "Asia/Kuwait-科威特",
                    "Africa/Nairobi-东部非洲标准时间(内罗毕)",
                    "Asia/Tehran-伊朗标准时间(德黑兰)",
                    "Asia/Baku-巴库",
                    "Asia/Tbilisi-第比利斯",
                    "Asia/Yerevan-埃里温",
                    "Asia/Dubai-迪拜",
                    "Asia/Kabul-阿富汗时间(喀布尔)",
                    "Asia/Karachi-卡拉奇",
                    "Asia/Oral-乌拉尔",
                    "Asia/Yekaterinburg-叶卡捷林堡",
                    "Asia/Calcutta-加尔各答",
                    "Asia/Colombo-科伦坡",
                    "Asia/Katmandu-尼泊尔时间(加德满都)",
                    "Asia/Almaty-阿拉木图",
                    "Asia/Rangoon-缅甸时间(仰光)",
                    "Asia/Krasnoyarsk-克拉斯诺亚尔斯克",
                    "Asia/Bangkok-曼谷",
                    "Asia/Shanghai-中国标准时间(北京)",
                    "Asia/Hong_Kong-香港时间(香港)",
                    "Asia/Irkutsk-伊尔库茨克时间(伊尔库茨克)",
                    "Asia/Kuala_Lumpur-吉隆坡",
                    "Australia/Perth-佩思",
                    "Asia/Taipei-台北时间(台北)",
                    "Asia/Seoul-首尔",
                    "Asia/Tokyo-日本时间(东京)",
                    "Asia/Yakutsk-雅库茨克时间(雅库茨克)",
                    "Australia/Adelaide-阿德莱德",
                    "Australia/Darwin-达尔文",
                    "Australia/Brisbane-布里斯班",
                    "Australia/Hobart-霍巴特",
                    "Australia/Sydney-悉尼",
                    "Asia/Vladivostok-海参崴时间(符拉迪沃斯托克)",
                    "Pacific/Guam-关岛",
                    "Asia/Magadan-马加丹时间(马加丹)",
                    "Pacific/Auckland-奥克兰",
                    "Pacific/Fiji-斐济",
                    "Pacific/Tongatapu-东加塔布",
                ]
            }
        },

        mounted() {
            // console.log("locale " + this.localeList[0].split("-")[0] + "-" + this.localeList[0].split("-")[1])
            this.myDomain = document.domain ? document.domain : window.location.hostname
            if (this.myDomain == "127.0.0.1") {
                this.myDomain = this.$store.getters.shinoIp()
            }
            // console.log(this.$store.state.orekiIp+"/" + this.$store.state.webIp)
            console.log("myDomain is " + this.myDomain)
            let that = this
            that.$post(that.$uri.system.paramGet, {paramName: 'cameraUpFrameRate'}).then(res => {
                if (res.success) {
                    this.frameRate = res.data.paramValue
                }
            })

            that.$post(that.$uri.system.paramGet, {paramName: 'cameraUpCodeRate'}).then(res => {
                if (res.success) {
                    this.codeRate = res.data.paramValue
                }
            })

            this.left = this.windowLeft
            this.top = this.windowTop

            LongeneClient.LoggingControl.setLogLevel('info');
            let phoneShow = false
            if (this.engineType === 21 || this.engineType === 17 || this.engineType === 22 || this.engineType === 23 || this.engineType === 24 || this.engineType === 32) {
                phoneShow = true
            }

            this.player = LongeneClient.createAppPlayer('target' + this.id, {
                keyboard: true,
                orientation: 'portrait',
                phoneShow: phoneShow
                // enableRemoteCamera: true
            });

            this.player.on('error', (error) => {
                if (error && error.message && error.code) {
                    this.error = true
                    this.deviceMessage = error.message + '(' + error.code + ')';
                }
            })
            this.deviceMessage = '正在连接中...';
            this.player.on('statechange', () => {
                if (this.player.state == 'playing') {
                    this.deviceMessage = '';
                    this.status = true
                    if (this.openVideo) {
                        this.player.openLocalVideo(this.openVideo)
                    }
                }
            })
            this.player.on('networkinfo', network => {
                // console.log(network)
            })
            this.openPlayer()
        },
        beforeDestroy() {
            this.player.close();
            if (this.cpuTimer) {
                clearInterval(this.cpuTimer)
                this.cpuTimer = null
            }
        },
        filters: {
            localeValue(item) {
                return item.split("-")[0] + "-" + item.split("-")[1]
            },
            timeZoneValue(item) {
                return item.split("-")[0]
            }
        },
        computed: {
            windowLeft() {
                let clientWidth = document.documentElement.clientWidth;
                let windowLeft = Math.floor((clientWidth - this.deviceWidth) / 2) + 20 * this.index;
                //service flowSync: 6
                if (this.checkLicenseService(6) !== -1) {
                    if (this.$store.state.displayMode) {
                        windowLeft = windowLeft + this.index * 30
                    } else {
                        let index = this.index + this.$store.state.videoInfo.length + this.$store.state.cameraInfo.length
                        windowLeft = this.deviceWidth * (index % Math.floor(clientWidth / this.deviceWidth));
                    }
                }
                return windowLeft > 0 ? windowLeft : 0;
            },
            windowTop() {
                let clientHeight = document.documentElement.clientHeight;
                let windowTop = Math.floor((clientHeight - this.deviceHeight - 36 * 2) / 2);
                //service flowSync: 6
                if (this.checkLicenseService(6) !== -1) {
                    if (this.$store.state.displayMode) {
                        windowTop += this.index * 40
                    } else {
                        let index = this.index + this.$store.state.videoInfo.length + this.$store.state.cameraInfo.length
                        windowTop = 80 * Math.floor(index / Math.floor(document.documentElement.clientWidth / this.deviceWidth))
                    }
                }
                return windowTop > 0 ? windowTop : 0;
            }
        },
        methods: {
            clickMeNow() {
                // console.log("click me id " + this.id)
                this.$store.commit(this.$mutation.DEVICE_WINDOW_SHOW_LATEST, this.id)
            },
            checkLicenseService(index) {
                let found = -1
                if (this.$store.state.licenseInfo && this.$store.state.licenseInfo.service) {
                    let serviceItems = this.$store.state.licenseInfo.service.toString().split(",")
                    serviceItems.forEach(item => {
                        // console.log("item is " + item + ", index is " + index)
                        if (item == index) {
                            found = 1
                            return
                        }
                    })
                }
                return found
            },
            openModelEdit() {
                this.currentPlaceHolder = '请输入'
                this.modelEdit = true
            },
            confirmModelEdit() {
                let that = this
                that.modelEditable = false
                let deviceIps = []
                deviceIps.push(that.ip)
                that.$post(that.$uri.device.switchRoot, {
                    deviceIps: deviceIps,
                    isRoot: that.modelInfo.isRoot
                }).then(res => {
                    if (res.success) {
                        // that.$message.success("ROOT开关设置成功")
                        that.$post(that.$uri.devMaster.editDeviceParam, {deviceIp: that.ip, ...that.modelInfo}).then(res => {
                            if (res.success) {
                                that.$message.success("修改机型参数成功")
                                that.modelEditable = true
                                that.showModelClick()
                            } else {
                                that.$message.error("修改机型参数失败")
                                that.modelEditable = true
                            }
                        }).catch(() => {
                            that.$message.error("通讯失败")
                            that.modelEditable = true
                        })
                    } else {
                        that.$message.error("修改机型参数失败")
                        that.modelEditable = true
                    }
                }).catch(() => {
                    that.$message.error("通讯失败")
                    that.modelEditable = true
                })

                this.modelEdit = false
            },
            cancelModelEdit() {
                this.modelEdit = false
            },
            getCurrentTime() {
                let current = new Date();
                return (current.getMinutes() > 9 ? current.getMinutes() : '0' + current.getMinutes()) + ':' + (current.getSeconds() > 9 ? current.getSeconds() : '0' + current.getSeconds())
            },
            processCpuValue(value) {
                this.currentCpu.push(value)
                if (this.currentCpu.length > 8) {
                    this.currentCpu.shift()
                    // console.log("currentCpu is " + JSON.stringify(this.currentCpu))
                }
                let time = this.getCurrentTime()
                this.currentTime.push(time)
                if (this.currentTime.length > 8) {
                    this.currentTime.shift()
                    // console.log("currentTime is " + JSON.stringify(this.currentTime))
                }
            },
            getEchartData() {
                // let random = parseInt(Math.random() * 100)
                // this.currentCpu.push(random)
                let that = this
                that.$post(that.$uri.device.edit, {deviceIp: that.ip}).then(res => {
                    // console.log("res is " + JSON.stringify(res))
                    if (res.success && res.data.cpu) {
                        that.processCpuValue(res.data.cpu)
                        that.showCpuEchart()
                    } else {
                        that.processCpuValue(0)
                        that.showCpuEchart()
                    }
                }).catch(() => {
                    that.$message.error("通讯失败")
                })
            },
            showModelClick() {
                let that = this
                this.currentPlaceHolder = '获取中...'
                // console.log("deviceIp: " + that.ip)
                that.$post(that.$uri.device.getDeviceParam, {deviceIp: that.ip}).then(res => {
                    console.log("res is " + JSON.stringify(res))
                    that.currentPlaceHolder = '无'
                    if (res.success) {
                        that.modelInfo = res.data
                    } else {
                        that.$message.error("获取机型参数失败")
                        that.currentPlaceHolder = '获取失败'
                    }
                }).catch(() => {
                    that.$message.error("通讯失败")
                    that.currentPlaceHolder = '获取失败'
                })
                this.phoneParamShow = true
            },
            showCpuClick() {
                this.cpuShow = !this.cpuShow
                let that = this
                if (this.cpuShow == true) {
                    this.$nextTick().then(() => {
                        that.getEchartData()
                    })
                    that.cpuTimer = setInterval(() => {
                        if (that.cpuShow === false) {
                            clearInterval(that.cpuTimer)
                            return
                        }
                        that.getEchartData()
                    }, 5000)
                } else {
                    if (this.cpuTimer) {
                        clearInterval(this.cpuTimer)
                        this.cpuTimer = null
                    }
                }
            },
            showCpuEchart() {
                console.log("id is " + this.id)
                var myChart = this.$echarts.init(document.getElementById('cpu_box' + this.id))

                var option = {
                    //标题
                    title: {
                        text: '当前CPU使用率' + this.currentCpu.slice(-1)[0] + '%'
                    },
                    grid: {
                        left: '3%',   //图表距边框的距离
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis'
                    },

                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: this.currentTime,
                        //坐标轴颜色
                        axisLine: {
                            lineStyle: {
                                color: 'gray'
                            }
                        },
                        //x轴文字旋转
                        axisLabel: {
                            rotate: 30,
                            interval: 0
                        },
                    },

                    yAxis: {
                        max: 100,
                        // min:0,
                        type: 'value',
                        minInterval: 0,
                        interval: 25, //每次增加几个
                    },
                    //数据-data是最终要显示的数据
                    series: [{
                        name: '',
                        type: 'line',
                        symbolSize: 4,
                        areaStyle: {
                            normal: {color: '#80ffc0'}
                        },
                        color: ['blue'],
                        data: this.currentCpu
                    }]
                };
                //使用刚刚指定的配置项和数据项显示图表
                myChart.setOption(option);
            },

            openPlayer() {
                this.deviceMessage = '连接中...'
                this.error = false
                let shinoIp = this.$store.getters.shinoIp();
                let that = this;
                // console.log("deviceNo is " + deviceNo)
                that.$post(that.$uri.device.getFlowDeviceId, {deviceIp: that.ip}).then(res => {
                    // console.log("res is " + JSON.stringify(res));
                    if (res.success && res.data) {
                        let flowDeviceId = res.data
                        that.player.open({
                            appkey: that.appkey,
                            appid: that.appid,
                            ljyip: shinoIp,
                            domain_name: that.myDomain,
                            domain: that.myDomain,
                            deviceId: flowDeviceId,
                            requestUrl: window.location.host + '/' + that.requestUrl,
                            reportUrl: window.location.host + '/' + that.reportUrl
                        });
                    } else {
                        that.player.open({
                            appkey: that.appkey,
                            appid: that.appid,
                            ljyip: shinoIp,
                            domain_name: that.myDomain,
                            domain: that.myDomain,
                            deviceId: that.deviceId,
                            requestUrl: window.location.host + '/' + that.requestUrl,
                            reportUrl: window.location.host + '/' + that.reportUrl
                        });
                    }
                });

            },
            copyLink() {
                this.$copyText('chrome://flags/#unsafely-treat-insecure-origin-as-secure').then(res => {
                    this.$message.success("复制成功")
                }, res => {
                    this.$message.error("复制失败")
                })
            },
            copyIp() {
                this.$copyText('http://' + this.myDomain).then(res => {
                    this.$message.success("复制成功")
                }, res => {
                    this.$message.error("复制失败")
                })
            },
            goFun() {
                this.cameraErrorVisible = false
                this.$store.dispatch(this.$action.GO_FUN, '浏览器摄像头权限获取')
            },
            downloadPng() {
                let downloadHref = '/snapshot/' + this.deviceId + '.png?temp=' + Math.random()
                let filename = this.deviceId + '.png'
                let a = document.createElement('a')
                a.href = downloadHref
                a.download = filename
                a.click()
            },
            computeDeviceSize() {
                let clientWidth = document.documentElement.clientWidth;

                this.deviceWidth = Math.floor(clientWidth * 0.25);
                this.deviceHeight = Math.floor(this.deviceWidth * 16 / 9);

                if (this.player) {
                    let orientation = this.player.orientation;
                    if (orientation == 'landscape') {
                        let width = this.deviceWidth;
                        this.deviceWidth = this.deviceHeight;
                        this.deviceHeight = width;
                    }
                    setTimeout(() => {
                        this.player.updateInterface();
                    }, 50)
                }
            },

            closeClick() {
                if (this.player) {
                    this.player.close();
                }
                this.$emit('close')
            },
            getCameraList() {
                if (navigator.mediaDevices === undefined) {
                    this.cameraErrorVisible = true
                } else {
                    navigator.mediaDevices.getUserMedia({video: true}).then(stream => {
                        stream.getTracks()[0].stop()
                        navigator.mediaDevices.enumerateDevices().then(devs => {
                            // console.log(devs)
                            let cameras = devs.filter(dev => dev.kind === 'videoinput' && dev.label)
                            this.cameraOption = cameras
                            if (cameras.length === 1) {
                                this.openLocalCamera(cameras[0].deviceId)
                            } else if (cameras.length === 0) {
                                this.$message.error('没有可用摄像头')
                            } else {
                                this.cameraSelectVisible = true
                                this.videoDeviceId = cameras[0].deviceId
                            }
                        }).catch(err => {
                            // console.log(err)
                            this.cameraErrorVisible = true
                        })
                    }).catch(res => {
                        // console.log('fail: ')
                        // console.log(res)
                        this.cameraErrorVisible = true
                    })
                }
            },
            openLocalCamera(videoDeviceId) {
                // console.log("openLocalCamera " + videoDeviceId);
                this.videoDeviceId = videoDeviceId
                this.cameraSelectVisible = false
                let arr = this.cameraOption.filter(ca => ca.deviceId === videoDeviceId)
                let label = arr[0].label

                this.$store.commit(this.$mutation.CAMERA_SHOW_MODE, {
                    show: true,
                    left: this.left + this.deviceWidth,
                    top: this.top,
                    videoDeviceId,
                    label
                })
                // console.log("this.videoDeviceId " + this.videoDeviceId)
                this.$parent.$nextTick().then(() => {
                    this.camera = true
                    let promise

                    let param = {
                        videoDeviceId
                    }
                    if (this.codeRate && this.frameRate) {
                        param.frameRate = this.frameRate
                        param.bandwidth = this.codeRate
                    }
                    if (this.$store.getters.getCameraWeight(videoDeviceId) > 1) {
                        promise = this.player.openLocalCamera(null, param)
                    } else {
                        let cameraMedia = document.getElementById('localCamera-' + videoDeviceId)
                        promise = this.player.openLocalCamera(cameraMedia, param)
                    }
                    promise.then(() => {
                        // console.log('camera success!')
                    }).catch(err => {
                        this.cameraErrorVisible = true
                        // console.log(err)
                    })
                })

            },
            setCameraRotation() {
                this.rotation = (this.rotation + 90) % 360
                console.log("setCameraRotation " + this.rotation)
                this.player.setCameraRotation(this.rotation)
            },
            closeLocal() {
                this.camera ? this.closeLocalCamera() : this.closeLocalVideo()
            },
            closeLocalCamera() {
                // console.log("closeLocalCamera: " + this.videoDeviceId)
                this.$store.commit(this.$mutation.CAMERA_SHOW_MODE, {show: false, videoDeviceId: this.videoDeviceId})
                this.camera = false
                this.player.closeLocalCamera()
            },
            openLocalVideo() {
                this.video = true
                this.localId = new Date().getTime()
                this.$parent.video.id = this.localId
                this.$parent.video.players = [this.player]
                this.$parent.video.left = this.left + this.deviceWidth
                this.$parent.video.top = this.top
                this.$parent.video.many = false
                this.$parent.video.show = true
                this.$parent.selectShow = true
                this.$parent.$nextTick().then(() => {
                    document.getElementById('videoFiles').click()
                })
            },
            closeLocalVideo() {
                // console.log("closeLocalVideo")
                this.video = false
                this.$store.commit(this.$mutation.VIDEO_SHOW_MODE, {
                    show: false,
                    player: this.player,
                    ref: this.many ? 'ref' + this.id : null
                })
                this.player.closeLocalVideo()
            },
            showLocal(show) {
                if (this.camera) {
                    this.$store.commit(this.$mutation.CAMERA_SHOW_MODE, {
                        display: true,
                        show,
                        videoDeviceId: this.videoDeviceId
                    })
                } else {
                    this.$store.commit(this.$mutation.VIDEO_SHOW_MODE, {display: true, show, id: this.localId})
                }
            },
            returnClick() {
                if (this.player) {
                    this.player.emitBack();
                }
            },

            homeClick() {
                if (this.player) {
                    this.player.emitHome();
                }
            },
            snapshotClick() {
                let that = this
                that.$post(that.$uri.device.snapshot, {deviceIp: that.ip, isSave: 1, isRetImg: 1}).then(res => {
                    that.url = res.data
                    that.dialogVisible = true
                })
            },

            recentClick() {
                if (this.player) {
                    this.player.openRecent();
                }
            },

            volUpClick() {
                if (this.player) {
                    this.player.emitVolumeUp();
                }
            },

            volDownClick() {
                if (this.player) {
                    this.player.emitVolumeDown();
                }
            },

            scaleModeChange() {
                // console.log('ddddddddddddddddd')
                if (this.scaleMode) {
                    this.scaleMode = 0
                    this.deviceWidth = 288
                    this.deviceHeight = 512
                } else {
                    this.scaleMode = 1
                    this.deviceWidth = 384
                    this.deviceHeight = 684
                }
                if (this.player) {
                    let orientation = this.player.orientation;
                    if (orientation == 'landscape') {
                        let width = this.deviceWidth;
                        this.deviceWidth = this.deviceHeight;
                        this.deviceHeight = width;
                    }
                    setTimeout(() => {
                        this.player.updateInterface();
                    }, 50)
                }
            },

            toogleOrientationClick() {
                if (this.player) {
                    let width = this.deviceWidth;
                    this.deviceWidth = this.deviceHeight;
                    this.deviceHeight = width;
                    // console.log("deviceWidth " + this.deviceWidth)
                    // console.log("deviceHeight " + this.deviceHeight)
                    let orientation = this.player.orientation;
                    if (orientation == 'portrait') {
                        this.player.setOrientation('landscape');
                    } else {
                        this.player.setOrientation('portrait');
                    }

                    setTimeout(() => {
                        this.player.updateInterface();
                    }, 50)
                }
            }
        }
    };
</script>

<style lang="less" scoped>
    .device {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2000;
        pointer-events: none;

        .window {
            pointer-events: visible;
            .header {
                height: 36px;
                background: #111;
                text-align: center;
                font-size: 18px;
                line-height: 36px;
                color: #fff;
                cursor: move;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                .id {
                    flex-grow: 1;
                    text-align: left;
                    /*float: left;*/
                    line-height: 36px;
                    padding: 0 10px;
                }
                .close {
                    /*float: right;*/
                    line-height: 36px;
                    padding: 0 10px 0 0;
                    cursor: pointer;
                }
            }
            .body-area {
                position: relative;
                display: flex;
                flex-direction: row;
            }
            .body {
                position: relative;
                background: #000;

                .message {
                    position: absolute;
                    color: #fff;
                    top: 50%;
                    left: 50%;
                    z-index: 1;
                    transform: translate(-50%, -50%);
                }
            }
            .body-right {
                position: relative;
                background: transparent;
                width: 32px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
            }
            .phone-param {
                position: absolute;
                border: 1px solid #409EFF;
                /*border-left: none;*/
                background-color: white;
            }
            .phone-param_header {
                width: 100%;
                height: 5%;
                display: flex;
                flex-direction: row;
                background-color: #409EFF;
                color: white;
                align-items: center;
                justify-content: space-between;
            }
            .phone-param_body {
                width: 100%;
                height: 82%;
                /*background-color: red;*/
                border-bottom: 1px solid #ddd;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                overflow-y: scroll;
                overflow-x: hidden;
                padding: 10px 0px 0px 10px;
                margin-bottom: 10px;
                .el-form {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    .el-input {
                        width: 160px;
                    }
                }
            }
            .phone-param_body::-webkit-scrollbar {
                display: none;
            }
            /*.phone-param_span {*/
            /*width: 90%;*/
            /*height: 20px;*/
            /*line-height: 20px;*/
            /*font-size: 14px;*/
            /*text-align: left;*/
            /*!*vertical-align:middle;*!*/
            /*margin: 10px 10px 8px 10px;*/
            /*padding-bottom:8px;*/
            /*!*background-color: red;*!*/
            /*text-overflow: ellipsis;*/
            /*border-bottom: 1px solid #ddd;*/
            /*}*/
            .phone-param_footer {
                width: 100%;
                height: 10%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 0;
                bottom: 0;
            }
            .triangle_border_nw {
                width: 0;
                height: 0;
                border-width: 32px 32px 0 0;
                border-style: solid;
                border-color: #409EFF transparent transparent transparent;
                /*margin:40px auto;*/
                position: relative;
            }
            .triangle_border_nw:hover {
                width: 0;
                height: 0;
                border-width: 32px 32px 0 0;
                border-style: solid;
                border-color: #66B1FF transparent transparent transparent;
                /*margin:40px auto;*/
                position: relative;
            }
            .footer-cpu {
                position: absolute;
                left: 0;
                bottom: 0;
                background-color: white;
            }
            .cpu_header {
                width: 100%;
                height: 20px;
                display: flex;
                flex-direction: row;
                background-color: #409EFF;
                color: white;
                align-items: center;
                justify-content: space-between;
            }

            .footer {
                background: #111;
                height: 36px;
                display: flex;
                justify-content: space-around;
                align-items: center;

                & > div {
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                }

                .return {
                    background: url('../assets/i_back.png') no-repeat;
                    background-size: 100% 100%;
                }

                .snapshot {
                    background: url('../assets/i_jt.png') no-repeat;
                    background-size: 100% 100%;
                }

                .home {
                    background: url('../assets/i_home.png') no-repeat;
                    background-size: 100% 100%;
                }

                .recent {
                    background: url('../assets/i_drw.png') no-repeat;
                    background-size: 100% 100%;
                }

                .vol-up {
                    background: url('../assets/i_ya.png') no-repeat;
                    background-size: 100% 100%;
                }

                .vol-down {
                    background: url('../assets/i_ys.png') no-repeat;
                    background-size: 100% 100%;
                }

                .toogle-orientation {
                    background: url('../assets/i_hsp.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }

</style>
